import { render, staticRenderFns } from "./NotificationsDrawer.vue?vue&type=template&id=6b49c25e&scoped=true&"
import script from "./NotificationsDrawer.vue?vue&type=script&lang=js&"
export * from "./NotificationsDrawer.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsDrawer.vue?vue&type=style&index=0&id=6b49c25e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b49c25e",
  null
  
)

export default component.exports